/*@ngInject*/
const FormTemplateBrowserActionRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.loadActions = function () {
        var url = '/rest/Actions',
            config = {
                params: {
                    uri: 'com.firstbest.underwriting.form.ui.UIFormTemplate:null'
                }
            };

        return this.get(url, config);
    };
};

angular.module('ums.configuration')
    .service('formTemplateBrowserActionRepository', FormTemplateBrowserActionRepository);
